import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAnchor, FiDatabase, FiGitCommit, FiShield, FiKey, FiBook, FiActivity, FiSettings, FiHelpCircle, FiPlayCircle } from 'react-icons/fi';

const navItems = [
  { id: 'overview', label: 'Harbor Overview', icon: FiAnchor },
  { id: 'how-it-works', label: 'Demo / Workflow', icon: FiPlayCircle },
  { id: 'catalog', label: 'Dataset Docks', icon: FiDatabase },
  { id: 'lineage', label: 'Lineage Paths', icon: FiGitCommit },
  { id: 'quality', label: 'Quality Beacons', icon: FiShield },
  { id: 'access', label: 'Access Bay', icon: FiKey },
  { id: 'faq', label: 'Support / FAQ', icon: FiHelpCircle },
];

export default function Sidebar({ currentView, setCurrentView }) {
  return (
    <aside className="w-64 h-screen border-r border-[var(--border-ocean)] bg-[var(--bg-ocean)] flex flex-col pt-6 flex-shrink-0 relative z-10">
      <div className="px-6 mb-10 flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[var(--surface-ocean-light)] border border-[var(--border-ocean)] flex items-center justify-center shadow-[0_0_15px_var(--schema-teal-dim)]">
          <SafeIcon icon={FiAnchor} className="text-[var(--schema-teal)] text-xl" />
        </div>
        <div>
          <h1 className="text-xl font-bold text-gradient tracking-wider">DataHarbor</h1>
          <p className="text-[10px] text-[var(--schema-teal)] tracking-widest uppercase opacity-80">Enterprise Catalog</p>
        </div>
      </div>

      <nav className="flex-1 px-3 space-y-1 overflow-auto">
        {navItems.map((item) => (
          <div
            key={item.id}
            onClick={() => setCurrentView(item.id)}
            className={`nav-item ${currentView === item.id ? 'active' : ''}`}
          >
            <SafeIcon icon={item.icon} className="text-lg" />
            <span className="font-medium text-sm">{item.label}</span>
          </div>
        ))}
      </nav>

      <div className="p-6 border-t border-[var(--border-ocean)]">
        <div className="nav-item mb-4">
          <SafeIcon icon={FiSettings} className="text-lg" />
          <span className="font-medium text-sm">Settings</span>
        </div>
        <div className="text-[10px] text-[var(--pearl-muted)] text-center opacity-70 font-mono tracking-tighter">
          Made by LingLink AI<br/>and DigLab AI
        </div>
      </div>
    </aside>
  );
}